export default __webpack_public_path__ + "static/media/avantages-membres-employers.ab0e247e.jpg";